// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2W-xT","left":"StickyBox_left__s4y9D","right":"StickyBox_right__2JxwO"};